import moment from 'moment';

import { RowData } from '../useDocuments';

import { deleteDocument, postDocumentData, putDocumentData } from '.';

const checkIfEdited = (
  documentId: number,
  allData: RowData[],
  defaultData: RowData[],
) => {
  const selectedDocumentDefaultData = defaultData.find(
    (dd) => dd.fDocumentId === documentId,
  );
  const selectedDocumentData = allData.find(
    (dd) => dd.fDocumentId === documentId,
  );
  if (!selectedDocumentDefaultData || !selectedDocumentData) {
    return false;
  }
  let changed = false;
  Object.keys(selectedDocumentData).forEach((edkey) => {
    if (
      selectedDocumentDefaultData[edkey as keyof RowData] !==
      selectedDocumentData[edkey as keyof RowData]
    ) {
      changed = true;
      return;
    }
  });
  return changed;
};

const putNewDocument = async (doc: RowData, empId: number, iDocId: number) => {
  await putDocumentData(newDocumentFormData(doc), empId, iDocId);
};

const postNewDocument = async (eq: RowData, empId: number) => {
  await postDocumentData(newDocumentFormData(eq), empId, 'form');
};

const convertDateString = (date: string) => {
  return moment(date).format('YYYY-MM-DD');
};

const newDocumentFormData = (eq: RowData) => {
  const formData = new FormData();
  formData.append('fDocumentDocType', eq.fDocumentDocType);
  formData.append(
    'fDocumentExpirationDate',
    eq.fDocumentExpirationDate
      ? convertDateString(eq.fDocumentExpirationDate)
      : '',
  );
  formData.append(
    'fDocumentCreated',
    eq.fDocumentCreated ? eq.fDocumentCreated : '',
  );
  formData.append(
    'fDocumentModified',
    eq.fDocumentModified ? convertDateString(eq.fDocumentModified) : '',
  );
  formData.append('fDocumentDescription', eq.fDocumentDescription || '');
  formData.append(
    'fDocumentId',
    eq.fDocumentId ? eq.fDocumentId.toString() : '-1',
  );
  formData.append('fDocumentName', eq.fDocumentName || '');
  if (eq.fDocumentAttachment) {
    formData.append('file', eq.fDocumentAttachment);
  }
  return formData;
};

export const dataSaving = async (
  empId: number,
  deletedRows: number[],
  editedRows: number[],
  defaultData: RowData[],
  data: RowData[],
) => {
  await Promise.all(
    deletedRows.map(async (row) => await deleteDocument(empId, row)),
  );
  await Promise.all(
    data.map(async (row) =>
      row.fDocumentId === -1 ? await postNewDocument(row, empId) : undefined,
    ),
  );
  await Promise.all(
    editedRows.map(async (row) => {
      if (checkIfEdited(row, data, defaultData)) {
        const selectedDocumentData = data.find(
          (dd) => dd.fDocumentId === row,
        ) as RowData;
        return await putNewDocument(selectedDocumentData, empId, row);
      }
      return undefined;
    }),
  );
};
